import React, { Component } from "react";

import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";

import { ValidationUtils } from "../Sidebar/Common";

export default class Deploymentstatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      touched: {}, // Track which fields have been touched

      filteredData: null,

      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.deploymentstatus_Id,

          sortable: true,

          cell: (row) => <span>{row.deploymentstatus_Id}</span>,
        },

        {
          name: "IT Tasktable Id",
          selector: (row, i) => row.ittaskstable_Id,
          sortable: true,
          cell: (row) => <span>{row.ittaskstable_Id}</span>,
        },
        {
          name: "Db Script",
          selector: (row, i) => row.dbScript,
          sortable: true,
          cell: (row) => <span>{row.dbScript}</span>,
        },
        {
          name: "Files",
          selector: (row, i) => row.files,
          sortable: true,
          cell: (row) => <span>{row.files}</span>,
        },
        {
          name: "Code Git Status",
          selector: (row, i) => row.codeGitStatus,
          sortable: true,
          cell: (row) => <span>{row.codeGitStatus}</span>,
        },
        {
          name: "Location",
          selector: (row, i) => row.location,
          sortable: true,
          cell: (row) => <span>{row.location}</span>,
        },

        {
          name: "Code Deployment Id",
          selector: (row, i) => row.codeDeploymentId,
          sortable: true,
          cell: (row) => <span>{row.codeDeploymentId}</span>,
        },
        {
          name: "Execution Status",
          selector: (row, i) => row.executionStatus,
          sortable: true,
          cell: (row) => <span>{row.executionStatus}</span>,
        },
        {
          name: "Execution Remarks",
          selector: (row, i) => row.executionRemarks,
          sortable: true,
          cell: (row) => <span>{row.executionRemarks}</span>,
        },
        {
          name: "Executed By",
          selector: (row, i) => row.executedBy,
          sortable: true,
          cell: (row) => <span>{row.executedBy}</span>,
        },
        {
          name: "Executed On",
          selector: (row, i) => row.executedOn,
          sortable: true,
          cell: (row) => <span>{row.executedOn}</span>,
        }, //***tableClms

        {
          name: "Actions",

          sortable: false,

          cell: (row) => (
            <div>
              {/* edit button and delete button */}

              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.DeploymentstatuseditHandler(row)}
                className="bi bi-pen"
              ></Button>

              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,

      itemsPerPage: 10,

      isEditing: false,

      deploymentstatus_Id: "",

      ittaskstable_Id: "",
      dbScript: "",
      files: "",
      yes_no: [],
      codeGitStatus: "",
      location: "",

      codeDeploymentId: "",
      executionStatus: "",
      executionRemarks: "",
      executedBy: "",
      executedOn: "", //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic

  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;

    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions

    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }

        break;

      case "mail":

      case "email":
        validationResult = ValidationUtils.validateEmail(value);

        break;

      case "telephone":

      case "phone":
        validationResult = ValidationUtils.validatePhone(value);

        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );

        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);

        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);

        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);

        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);

        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }

        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation

    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };

    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });

    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation

  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,

      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched

    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation

  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });

    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields

  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation

    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission

  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "ittaskstable_Id",
        inputType: "Text",
        displayName: "Task Id",
        validationOptions: { isRequired: false },
      },

      {
        fieldName: "dbScript",
        inputType: "Text",
        displayName: "Db Script",
        validationOptions: { isRequired: false },
      },

      {
        fieldName: "files",
        inputType: "Text",
        displayName: "Files",
        validationOptions: { isRequired: false },
      },

      {
        fieldName: "codeGitStatus",
        inputType: "Select",
        displayName: "Code Git Status",
        validationOptions: { isRequired: false },
      },

      {
        fieldName: "location",
        inputType: "Text",
        displayName: "Location",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];

      this.validateField(config.fieldName, value, config);
    });

    const touched = {};

    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });

    this.setState({ touched });
  };

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,

      errors: {},

      touched: {},

      ittaskstable_Id: "",
      dbScript: "",
      files: "",
      yes_no: [],
      codeGitStatus: "",
      location: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,

      isEditing: false,

      errors: {},

      touched: {},

      ittaskstable_Id: "",
      dbScript: "",
      files: "",
      yes_no: [],
      codeGitStatus: "",
      location: "",
    });
  };

  // Enhanced toast notifications

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg);

        break;

      default:
        toast.info(msg);
    }
  };

  DeploymentstatuseditHandler = (row) => {
    this.setState({
      isEditing: true,

      show: true,

      deploymentstatus_Id: row.deploymentstatus_Id,

      ittaskstable_Id: row.ittaskstable_Id,
      dbScript: row.dbScript,
      files: row.files,
      yes_no: [],
      codeGitStatus: row.codeGitStatus,
      location: row.location,

      codeDeploymentId: row.codeDeploymentId,
      executionStatus: row.executionStatus,
      executionRemarks: row.executionRemarks,
      executedBy: row.executedBy,
      executedOn: row.executedOn, //***editstate

      errors: {},

      touched: {},
    });
  };

  DeploymentstatusfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentstatus/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })

      .catch((error) => {
        console.error("Fetch error:", error);

        this.showToast("Failed to load data", "error");
      });
  };

  DeploymentstatussubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("ittaskstable_Id", this.state.ittaskstable_Id);

    formData.append("dbScript", this.state.dbScript);

    formData.append("files", this.state.files);

    formData.append("codeGitStatus", this.state.codeGitStatus);

    formData.append("location", this.state.location);

    formData.append("codeDeploymentId", this.state.codeDeploymentId);

    formData.append("executionStatus", this.state.executionStatus);

    formData.append("executionRemarks", this.state.executionRemarks);

    formData.append("executedBy", this.state.executedBy);

    formData.append("executedOn", this.state.executedOn);
    //***tableData*

    fetch(configData.api_url + "C_Deploymentstatus/add", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.DeploymentstatusfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            ittaskstable_Id: "",
            dbScript: "",
            files: "",
            yes_no: [],
            codeGitStatus: "",
            location: "",
          });
        }
      })

      .catch((error) => {
        console.error("Submit error:", error);

        this.showToast("Failed to save data", "error");
      });
  };

  DeploymentstatusupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("deploymentstatus_Id", this.state.deploymentstatus_Id);

    formData.append("ittaskstable_Id", this.state.ittaskstable_Id);

    formData.append("dbScript", this.state.dbScript);

    formData.append("files", this.state.files);

    formData.append("codeGitStatus", this.state.codeGitStatus);

    formData.append("location", this.state.location);

    formData.append("codeDeploymentId", this.state.codeDeploymentId);

    formData.append("executionStatus", this.state.executionStatus);

    formData.append("executionRemarks", this.state.executionRemarks);

    formData.append("executedBy", this.state.executedBy);

    formData.append("executedOn", this.state.executedOn);
    //***tableData1

    fetch(configData.api_url + "C_Deploymentstatus/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.DeploymentstatusfetchHandler();

          this.handleOffcanvasClose();
        }
      })

      .catch((error) => {
        console.error("Update error:", error);

        this.showToast("Failed to update data", "error");
      });
  };

  componentDidMount() {
    this.DeploymentstatusfetchHandler();

    this.yes_nofetchHandler();

    //***componentDidMount
  }

  handleittaskstable_IdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ ittaskstable_Id: fieldValue });
  };
  handledbScriptChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dbScript: fieldValue });
  };
  handlefilesChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ files: fieldValue });
  };
  handlecodeGitStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ codeGitStatus: fieldValue });
  };
  yes_nofetchHandler = () => {
    fetch(configData.api_url + "C_Yes_no/list", {
      // Enter your IP address here

      method: "POST",

      mode: "cors",

      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ yes_no: data.list });
        }
      });
  };
  handlelocationChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ location: fieldValue });
  };

  handlecodeDeploymentIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ codeDeploymentId: fieldValue });
  };
  handleexecutionStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ executionStatus: fieldValue });
  };
  handleexecutionRemarksChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ executionRemarks: fieldValue });
  };
  handleexecutedByChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ executedBy: fieldValue });
  };
  handleexecutedOnChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ executedOn: fieldValue });
  }; //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(`Are you sure you want to delete this deploymentstatus?`)
    ) {
      return;
    }

    var formData = new FormData();

    formData.append("deploymentstatus_Id", row.deploymentstatus_Id);

    fetch(configData.api_url + "C_Deploymentstatus/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.DeploymentstatusfetchHandler();
        }
      })

      .catch((error) => {
        console.error("Delete error:", error);

        this.showToast("Failed to delete data", "error");
      });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  // Helper method to render error message

  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;

    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>

          {errors[fieldName]}
        </div>
      );
    }

    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options

  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;

    const value = this.state[fieldName] || "";

    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":

      case "dob_adult":

      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );

        break;

      case "telephone":

      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );

        break;

      case "mail":

      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );

        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );

        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );

        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );

        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );

        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}

            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>

        <Col lg="8" md="8">
          {inputElement}

          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,

          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,

          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline































                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Deployment Status
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}

                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Deploymentstatus
                          </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}

                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>

                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleittaskstable_IdChange
                                        }
                                        className="form-control"
                                        name="ittaskstable_Id"
                                        value={this.state.ittaskstable_Id}
                                        required="required"
                                        placeholder="Enter Task Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.ittaskstable_Id}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Db Script
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledbScriptChange}
                                        className="form-control"
                                        name="dbScript"
                                        value={this.state.dbScript}
                                        required="required"
                                        placeholder="Enter Db Script"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dbScript}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Files
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlefilesChange}
                                        className="form-control"
                                        name="files"
                                        value={this.state.files}
                                        required="required"
                                        placeholder="Enter Files"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.files}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Code Git Status
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="tableName"
                                        onChange={
                                          this.handlecodeGitStatusChange
                                        }
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Code Git Status{" "}
                                        </option>

                                        {this.state.yes_no.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.value}
                                            >
                                              {" "}
                                              {api.value}{" "}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.codeGitStatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Location
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlelocationChange}
                                        className="form-control"
                                        name="location"
                                        value={this.state.location}
                                        required="required"
                                        placeholder="Enter Location"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.location}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Execution Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        className="form-select"
                                        onChange={
                                          this.handleexecutionStatusChange
                                        }
                                        name="executionStatus"
                                        value={this.state.executionStatus}
                                        required="required"
                                        placeholder="Enter Execution Status"
                                      >
                                        <option value="">Select</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Executed">
                                          Executed
                                        </option>
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.executionStatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.DeploymentstatussubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}

                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Deploymentstatus
                            </Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}

                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>

                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Task Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleittaskstable_IdChange
                                          }
                                          className="form-control"
                                          name="ittaskstable_Id"
                                          value={this.state.ittaskstable_Id}
                                          required="required"
                                          placeholder="Enter Task Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.ittaskstable_Id}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Db Script
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledbScriptChange}
                                          className="form-control"
                                          name="dbScript"
                                          value={this.state.dbScript}
                                          required="required"
                                          placeholder="Enter Db Script"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dbScript}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Files
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlefilesChange}
                                          className="form-control"
                                          name="files"
                                          value={this.state.files}
                                          required="required"
                                          placeholder="Enter Files"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.files}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Code Git Status
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="tableName"
                                          onChange={
                                            this.handlecodeGitStatusChange
                                          }
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Code Git Status{" "}
                                          </option>

                                          {this.state.yes_no.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.value}
                                              >
                                                {" "}
                                                {api.value}{" "}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.codeGitStatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Location
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlelocationChange}
                                          className="form-control"
                                          name="location"
                                          value={this.state.location}
                                          required="required"
                                          placeholder="Enter Location"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.location}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Execution Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          className="form-select"
                                          onChange={
                                            this.handleexecutionStatusChange
                                          }
                                          name="executionStatus"
                                          value={this.state.executionStatus}
                                          required="required"
                                          placeholder="Enter Execution Status"
                                        >
                                          <option value="">Select</option>
                                          <option value="Pending">
                                            Pending
                                          </option>
                                          <option value="Executed">
                                            Executed
                                          </option>
                                        </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.executionStatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>

                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.DeploymentstatusupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />

                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
